import React, { Component } from "react";
import { Link } from "react-router-dom";
import NavBarLogin from "./NavBarLogin";
import logo from "../Pages/logo.png";

class NavBar extends Component {

    render() {
        return (
            <nav className = "navbox">
                <img className = "logo" src={logo} alt="logo"></img>
                <Link to="/" className="active">
                    Home
                </Link>

                
                {/* <NavBarLogin/> */}
            </nav>
        )
    }
}

export default NavBar;
